import { Injectable } from '@angular/core';
import {
  NavigateAction,
  SearchActionHandler,
} from '@core/search';
import { SettingsNavigationService } from '../services/settings-navigation.service';

/**
 * Handles { type: 'navigate' } actions produced by SettingsSearchProvider.
 * Delegates the heavy lifting (route navigation + anchor scroll + highlight)
 * to the existing SettingsNavigationService.
 */
@Injectable({ providedIn: 'root' })
export class SettingsSearchActionHandler implements SearchActionHandler<NavigateAction> {
  readonly type = 'navigate' as const;

  constructor(private nav: SettingsNavigationService) {}

  handle(action: NavigateAction): void {
    const route = action.section ? `${action.route}#${action.section}` : action.route;
    this.nav.navigateToSetting(route);
  }
}
